import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=de270626&"
import script from "./Sticky.vue?vue&type=script&lang=js&"
export * from "./Sticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports